/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

export enum AttributeNames {
  DOCUMENT_LOAD = 'documentLoad',
  DOCUMENT_FETCH = 'documentFetch',
  RESOURCE_FETCH = 'resourceFetch',
}
